import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token when present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cl_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) => {
  const num = Number(n);
  const digits = Number.isInteger(num) ? 0 : 2;
  return `$${num.toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: 2 })}`;
};

// Round a dollar amount UP to the nearest whole dollar ending in 8 (mirrors backend _round_up_8).
export const roundUp8 = (x) => {
  const v = Math.round(Number(x) * 100) / 100;
  let n = Math.floor(v);
  if (v - n > 1e-9) n += 1;
  if (n < 8) return 8;
  const r = ((n % 10) + 10) % 10;
  return n + (r <= 8 ? 8 - r : 9);
};

// Estimated delivery: dispatch next business day + `transitDays` business days in transit.
export function deliveryEstimate(transitDays = 2) {
  const d = new Date();
  let added = 0;
  const target = 1 + transitDays; // 1 dispatch day + transit
  while (added < target) {
    d.setDate(d.getDate() + 1);
    const day = d.getDay();
    if (day !== 0 && day !== 6) added++;
  }
  return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
}
